angular.module('dnecom')
    .service('MediaUtils', ["$http", function ($http) {
        var ids = [];

        this.delete = function (ids, callback, errorCallback) {
            return $http.delete(Routing.generate('media_delete', {
                    ids: ids
                }))
                .then(function (response) {
                    if (callback) {
                        callback(response);
                    }
                }, function () {
                    if (errorCallback) {
                        errorCallback(response);
                    }
                });
        };

        this.scheduleDelete = function (id) {
            if (id !== null)
                ids.push(id);
        };

        this.cancelDelete = function (id) {
            var index = ids.indexOf(id);

            if (index > -1) {
                ids.splice(index, 1);
            }
        };

        this.processDelete = function (callback, errorCallback) {
            if (ids.length > 0) {
                this.delete(ids, callback, errorCallback);
            }

            ids = [];
        };

        return this;
    }]);
